import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC4cz2J4EXIp4z02E25RnfUBCYuCbVKzmU",
  authDomain: "u-jarvis.firebaseapp.com",
  projectId: "u-jarvis",
  storageBucket: "u-jarvis.firebasestorage.app",
  messagingSenderId: "143267074791",
  appId: "1:143267074791:web:b534839f5ca3a041540842",
  measurementId: "G-Z54RKLV580"
};

// Initialize Firebase only if it hasn't been initialized
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Services (Safety check for SSR contexts)
export let analytics;
if (app.name && typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;